import { ACTIONS as analyticsTrackerActions } from 'actions/analytics-tracker';
import uuid from 'uuid/v1';

export const ANALYTICS_FLOW = {
  PREDICT_PROBABLE_SHEET: 'PREDICT_PROBABLE_SHEET',
  SHEET_PERF_UNIQUE_ID: 'SHEET_PERF_UNIQUE_ID',
};

const initialState = {
  [ANALYTICS_FLOW.PREDICT_PROBABLE_SHEET]: uuid(),
  [ANALYTICS_FLOW.SHEET_PERF_UNIQUE_ID]: uuid(),
};

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === analyticsTrackerActions.RESET_ANALYTiCS_TRACKER) {
    return {
      ...state,
      [payload]: uuid(),
    };
  }

  return state;
}
